import React from 'react';

const SvgLogoAp = (props: any) => (
    <svg width={35} height={35} {...props}>
        <g fill="none" fillRule="evenodd">
            <path
                d="M0 17.478C0 7.842 7.843 0 17.522 0 27.157 0 35 7.842 35 17.478 35 27.158 27.157 35 17.522 35 7.842 35 0 27.158 0 17.478z"
                fill="#000C26"
            />
            <path
                d="M25.135 9.602c0-1.703.852-2.286 1.21-2.286v-.313c-2.464 0-3.226-2.555-3.226-3.003h-.224c-.807 1.344-3.272 2.017-5.02 2.375-1.433.269-2.867.403-3.988.807-1.434.493-2.375 1.344-2.375 3.137v11.83c-.493-.627-1.3-.806-2.061-.806-.762 0-3.451.135-3.451 3.45 0 3.317 2.24 5.065 5.198 5.065 4.795 0 7.53-3.316 9.098-5.333v1.524c0 2.196 1.882 3.226 2.913 3.764l4.391-3.047-.358-.493s-.762.582-1.21.582c-.583 0-.897-.582-.897-.985V9.602z"
                fill="#FFF"
            />
            <path
                d="M16.262 9.109c0-.807.852-1.703 1.883-1.703 1.254 0 2.106.851 2.106 1.658v6.543h-3.989V9.109zM20.25 17.49v3.405c0 3.047-2.42 5.423-6.497 5.423-2.734 0-3.316-1.255-3.316-1.255.358.09.851.09 1.254.09 2.017 0 4.571-.718 4.571-3.317V17.49h3.989z"
                fill="#000C26"
            />
            <path d="M10.347 24.615v-.762c0-.628.269-1.076.851-1.076h.314v.852c0 .896-.672.986-1.165.986z" fill="#000C26" />
        </g>
    </svg>
);

export default SvgLogoAp;
